import {
    Fastfood,
    Restaurant,
    LocalPizza,
    Storefront,
    ContentCut, // For salon/service businesses
} from "@mui/icons-material";
export const storeCards = [
    { 
        id: 0, 
        title: 'Fast Food / Pizzeria', 
        description: 'Quick service restaurants, pizza shops, and high-volume food service operations.', 
        icon: <Fastfood fontSize="large" color="primary" /> 
    },
    { 
        id: 1, 
        title: 'Fine Dining', 
        description: 'Upscale restaurants with sophisticated table management and guest reservation features.', 
        icon: <Restaurant fontSize="large" color="primary" /> 
    },
    { 
        id: 2, 
        title: 'Retail Store', 
        description: 'Manage inventory, barcodes, and retail sales with ease.', 
        icon: <Storefront fontSize="large" color="primary" /> 
    },
    { 
        id: 3, 
        title: 'Service-Based', 
        description: 'Salons, spas, barbershops with appointment booking and service management.', 
        icon: <ContentCut fontSize="large" color="primary" /> 
    }
];

export const planCards = [
    {
        id: 0,
        title: 'Basic',
        price: '$69',
        period: '/mo',
        description: 'Essential POS features for small startups.',
        features: [
            'POS Application',
            'Admin Panel',
            '1 Printer or KDS',
            'Payment & Cash Drawer',
            'Scanner Support',
            'Reports (1 Daily Report)'
        ]
    },
    {
        id: 1,
        title: 'Inventory Plus',
        price: '$79',
        period: '/mo',
        description: 'Advanced stock tracking and ingredient management.',
        features: [
            'Everything in Basic',
            'Full Inventory Module',
            'Stock Management',
            'Automatic Stock Alerts',
            'Stock & Inventory Reports'
        ]
    },
    {
        id: 2,
        title: 'Premium / Custom',
        price: 'Custom',
        period: '',
        description: 'Tailored solutions for enterprise-level operations.',
        features: [
            'Multi-terminal Support',
            'Advanced CRM Tools',
            'Custom Integrations',
            'Dedicated Support',
            'Multi-store Management'
        ]
    },
];